import {getAccessToken} from '@/services/infrastructure/auth.service'
import {getSelectedOrgId, myOrgs} from '@/tenants/org.service'
import {resolveEhfApiPath} from '@/services/infrastructure/ServerBasePathResolver'
import axios from 'axios'

const getHeaders = async (tenantId?: string): Promise<any> => {
    const accessToken = await getAccessToken()
    if (!accessToken) {
        console.error('Attempting to call backend API without a valid access token! Should not happen!')
        return
    }

    const tenantHeader = tenantId || getSelectedOrgId()
    const currentRoles = myOrgs.value?.find(org => org.id === tenantHeader)?.roles || []

    return {
        Authorization: `Bearer ${accessToken}`,
        tenantId: tenantHeader,
        'Conta-Tenant-User-Roles': btoa(currentRoles.join(',')) // Invalidate cache at banking
    }
}

//TODO: instead of using tenantId as optional parameter, use a full headers-object and allow overwriting with destructuring (like in POST)
const get = async (path: string, params: any = {}, headers: any = {}, tenantId?: string) => {
    try {
        const response = await axios.get(
            resolveEhfApiPath() + path,
            {
                headers: {
                    ...await getHeaders(tenantId),
                    ...headers
                },
                params: {
                    ...Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined))
                }
            }
        )
        return response.data
    } catch (e: any) {
        console.error(e)
    }
}

export {get}